export default __webpack_public_path__ + "static/media/image-loon-diva.53d9fa3e.svg";